import { useMutation, useQueryClient } from 'react-query';
import HudVoucherService from '../../services/hudVoucherService';

const useFinalizeApprovalMutation = ({
  organizationId,
  propertyId,
  hudVoucherId,
  setSubmissionStatusOverride,
  invalidateVoucherDetailQueries,
}) => {
  const queryClient = useQueryClient();

  return useMutation(
    (payload) => {
      const service = new HudVoucherService();
      return service.finalizeApproval(
        organizationId,
        propertyId,
        hudVoucherId,
        payload,
        { fullError: true },
      );
    },
    {
      onSuccess: async () => {
        setSubmissionStatusOverride('Approved');
        await invalidateVoucherDetailQueries();
        await queryClient.invalidateQueries('hudVouchers');
      },
      onError: () => {},
    },
  );
};

export default useFinalizeApprovalMutation;
